module.exports = __webpack_public_path__ + "static/media/945HorizontalLogo.80c7cb51.svg";